(function () {
  /**
   * @ngdoc module
   * @name app.widgets.products.product-segment-usage
   * @description module that defines product-segment-usage widgets
   */
  angular.module('app.widgets.products.product-segment-usage', [
    'app.widgets.common.feature',
    'binky.core.lodash',
    'rcControllers.consumableUsageModal',
    'rcControllers.licenseDelegationDetailModal',
    'rcFilters.date',
    'rcFilters.numberFormatter',
    'rcFilters.productToProductName',
    'rcFilters.regionCodeToLanguage',
    'rcServices.user',
  ]);
})();
